import React from 'react';
import { Globe } from 'lucide-react';
import { buildSubdomainUrl, buildDisplayDomain } from '../../../utils/domain';

const DesktopHeader = ({ portfolio }) => {
  const customDomain = portfolio?.data?.customDomain?.trim() || '';
  const displayDomain = buildDisplayDomain(customDomain);
  const href = buildSubdomainUrl(customDomain);

  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-xl font-semibold text-notion-text tracking-tight">Capture Tools</h1>
        <p className="text-xs text-notion-text-light mt-1">Manage your website, property sites, and QR codes.</p>
      </div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 text-xs font-medium text-stone-500 hover:text-stone-800 transition-colors px-3 py-1.5 rounded hover:bg-notion-sidebar"
      >
        <Globe className="w-3.5 h-3.5" /> {displayDomain}
      </a>
    </div>
  );
};

export default DesktopHeader;
